export default "__VITE_ASSET__CNgquFwZ__"